import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, notification, DatePicker } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import policyRequest from "../Policy/PolicyRequest";
import ReactQuill from "react-quill"; // Import ReactQuill
import "react-quill/dist/quill.snow.css"; // Import ReactQuill styles

export const AddTermsCondition = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [content, setContent] = useState(""); // State to store content from ReactQuill

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    const allFormData = { ...values, content }; // Include the content in the form data
    console.log(allFormData);

    policyRequest
      .createTermsConditions(allFormData)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          notification.success({
            message: "Terms & Condition added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add Terms & Condition",
        });
        console.error("API Error:", e);
      });
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Add Terms & Conditions</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <div className="subscription">
              {/* Replace Content field with ReactQuill */}
              <Form.Item
                name="content"
                label="Content"
                className="subscription-plan"
                style={{ width: "100%" }}
                rules={[
                  { required: true, message: "Please enter the content" },
                ]}
              >
                <ReactQuill
                  value={content}
                  onChange={setContent}
                  placeholder="Enter Content"
                  style={{ height: "300px", width: "100%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="versionNumber"
                label="Version Number"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the version number",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Version Number"
                />
              </Form.Item>
              <Form.Item
                name="effectiveDate"
                label="Effective Date"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the effective date",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Select Effective Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
